export default {
  pending: false,
  groups: []
}
